import { render, staticRenderFns } from "./TakedaLogoWithLogout.vue?vue&type=template&id=7cac6c13&"
import script from "./TakedaLogoWithLogout.vue?vue&type=script&lang=js&"
export * from "./TakedaLogoWithLogout.vue?vue&type=script&lang=js&"
import style0 from "./TakedaLogoWithLogout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports